const shaka = require('external/shaka-player.ui.debug');

const AirPlayButton = class extends shaka.ui.Element {
  constructor(parent: typeof AirPlayButton, controls: ShakaControl) {
    super(parent, controls);

    // The actual button that will be displayed
    this.button_ = document.createElement('button') as HTMLButtonElement;
    this.button_.textContent = 'AirPlay';
    this.button_.classList.add('shaka-airplay-button');

    this.parent.appendChild(this.button_);

    this.eventManager.listen(this.button_, 'click', () => {
      const video = this.player.getMediaElement();
      video.webkitShowPlaybackTargetPicker();
    });
  }
};

// Factory that will create a button at run time.
AirPlayButton.Factory = class {
  create(rootElement, controls) {
    return new AirPlayButton(rootElement, controls);
  }
};

export default AirPlayButton;
